import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as actions from './booking-search.actions';
import { BookingSearchState } from './booking-search.state';

/**
 * bookingSearch initial state
 */
export const bookingSearchInitialState: BookingSearchState = {
  model: null,
};

/**
 * List of basic actions for BookingSearch Store
 */
export const bookingSearchReducerFeatures: ReducerTypes<BookingSearchState, ActionCreator[]>[] = [
  on(actions.setBookingSearch, (_state, payload) => ({ ...payload })),

  on(actions.updateBookingSearch, (state, payload) => ({ ...state, ...payload })),

  on(actions.resetBookingSearch, () => bookingSearchInitialState),
];

/**
 * BookingSearch Store reducer
 */
export const bookingSearchReducer = createReducer(bookingSearchInitialState, ...bookingSearchReducerFeatures);
